import React from 'react'

function ViewDocument({label, filepath, placeholder}) {

  return (
    <div className="mb-3">
        <label for="formFile" className="form-label">{label}</label><br/>
        {filepath && <a href={filepath} target="_blank" className="doc-link">{placeholder}</a>}
    </div>
  )
}

export default ViewDocument